export const authClientId = process.env.REACT_APP_AUTH_CLIENT_ID || '';
export const authDomain = process.env.REACT_APP_AUTH_DOMAIN || '';
export const authApiIdentifier = process.env.REACT_APP_AUTH_API_ID || '';
export const graphqlHttpServer = process.env.REACT_APP_GRAPHQL_HTTP_SERVER || '';
export const graphqlWSServer = process.env.REACT_APP_GRAPHQL_WEBSOCKET_SERVER || '';
